import { apiClient } from './axios';
import {
    UserActivityResponse,
    RetentionResponse,
    RevenueResponse,
    LearningSummaryResponse,
    WordbookDetailResponse,
    AiOperationsResponse,
} from '../types/analytics';

export const analyticsApi = {
    getUserActivity: (startDate: string, endDate: string) =>
        apiClient.get<UserActivityResponse>(`/admin/analytics/user-activity?startDate=${startDate}&endDate=${endDate}`),

    getRetention: (startDate: string, endDate: string, segment: string = 'ALL') =>
        apiClient.get<RetentionResponse>(`/admin/analytics/retention?startDate=${startDate}&endDate=${endDate}&userSegment=${segment}`),

    getRevenue: (startDate: string, endDate: string) =>
        apiClient.get<RevenueResponse>(`/admin/analytics/revenue?startDate=${startDate}&endDate=${endDate}`),

    getLearningSummary: (startDate: string, endDate: string) =>
        apiClient.get<LearningSummaryResponse>(`/admin/analytics/learning/summary?startDate=${startDate}&endDate=${endDate}`),

    getWordbookDetail: (startDate: string, endDate: string) =>
        apiClient.get<WordbookDetailResponse>(`/admin/analytics/learning/wordbook-detail?startDate=${startDate}&endDate=${endDate}`),

    getAiOperations: (startDate: string, endDate: string) =>
        apiClient.get<AiOperationsResponse>(`/admin/analytics/ai-operations?startDate=${startDate}&endDate=${endDate}`),
};
